.verdict {
    display: flex;
    width: fit-content;
    margin-bottom: 6px;
}

// Markdown wraps an inline component in an inline-block span, which would
// keep the chip on the same line as the cell's detail.
span:has(> .verdict) {
    display: block;
}
